import { render, staticRenderFns } from "./StLocationOnlineAppointmentCta.vue?vue&type=template&id=487c7652"
import script from "./StLocationOnlineAppointmentCta.vue?vue&type=script&lang=ts"
export * from "./StLocationOnlineAppointmentCta.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports